module.exports = __webpack_public_path__ + "static/media/login.1c71ea19.png";